import {IWeapon} from "../_interfaces/IWeapon";

const weapons_close:IWeapon[] = [
    {
        name: "Breitschwert",
        attr: "str",
        dmg: 3,
        min_str: 7,
        size: 1,
        price: 25,
        weight: 1,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Dolch",
        attr: "str",
        dmg: 2,
        min_str: 4,
        size: 1,
        price: 0.8,
        weight: 0.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Dreizack",
        attr: "str",
        dmg: 5,
        min_str: 11,
        size: 4,
        price: 25,
        weight: 2,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Dreschflegel",
        attr: "str",
        dmg: 5,
        min_str: 10,
        size: 3,
        price: 35,
        weight: 2.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Handaxt",
        attr: "str",
        dmg: 4,
        min_str: 8,
        size: 2,
        price: 15,
        weight: 1.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Stangenwaffe",
        attr: "str",
        dmg: 8,
        min_str: 16,
        size: 6,
        price: 150,
        weight: 5,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Kampfstab",
        attr: "str",
        dmg: 4,
        min_str: 6,
        size: 5,
        price: 5,
        weight: 2,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Keule",
        attr: "str",
        dmg: 3,
        min_str: 7,
        size: 2,
        price: 2,
        weight: 1.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Kriegshammer",
        attr: "str",
        dmg: 7,
        min_str: 15,
        size: 5,
        price: 95,
        weight: 4,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Kurzschwert",
        attr: "str",
        dmg: 4,
        min_str: 8,
        size: 2,
        price: 16,
        weight: 1.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Messer",
        attr: "str",
        dmg: 1,
        min_str: 3,
        size: 1,
        price: 0.3,
        weight: 0.25,
        avail: "Alltäglich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Peitsche",
        attr: "str",
        dmg: 3,
        min_str: 7,
        size: 3,
        price: 10,
        weight: 1,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Scythische Axt",
        attr: "str",
        dmg: 5,
        min_str: 12,
        size: 3,
        price: 20,
        weight: 2,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Speer",
        attr: "str",
        dmg: 4,
        min_str: 9,
        size: 3,
        price: 9,
        weight: 1.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Stoßspeer",
        attr: "str",
        dmg: 5,
        min_str: 13,
        size: 5,
        price: 15,
        weight: 3.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Streitaxt",
        attr: "str",
        dmg: 7,
        min_str: 13,
        size: 5,
        price: 35,
        weight: 3,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Streitkolben",
        attr: "str",
        dmg: 4,
        min_str: 13,
        size: 3,
        price: 20,
        weight: 2.5,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Totschläger",
        attr: "str",
        dmg: 1,
        min_str: 3,
        size: 1,
        price: 3,
        weight: 1,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Trollaxt",
        attr: "str",
        dmg: 8,
        min_str: 17,
        size: 6,
        price: 45,
        weight: 4,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Trollschwert",
        attr: "str",
        dmg: 6,
        min_str: 13,
        size: 4,
        price: 50,
        weight: 3,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Windlingsschwert",
        attr: "str",
        dmg: 3,
        min_str: 6,
        size: 1,
        price: 45,
        weight: 0.5,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Windlingsspeer",
        attr: "str",
        dmg: 2,
        min_str: 4,
        size: 1,
        price: 25,
        weight: 2.5,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Windlingsstangenwaffe",
        attr: "str",
        dmg: 4,
        min_str: 7,
        size: 2,
        price: 55,
        weight: 1,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Zweihänder",
        attr: "str",
        dmg: 8,
        min_str: 15,
        size: 6,
        price: 125,
        weight: 3.5,
        avail: "Ungewöhnlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    },
    {
        name: "Zwergenschwert",
        attr: "str",
        dmg: 4,
        min_str: 12,
        size: 2,
        price: 6,
        weight: 1,
        avail: "Durchschnittlich",
        ranged:false, short_f:0, short_t:0, far_f:0, far_t:0
    }
];
export default weapons_close